import { DecisionTreeQuestion } from '../../../../@types';

export const hidePreviousQuestions = (questions: DecisionTreeQuestion[], id: number) => {
  return questions.map((q) => {
    if (q.id < id && !q.answer) {
      q.hide = true;
    }
    return q;
  });
};

export const hideUnansweredQuestions = (questions: DecisionTreeQuestion[]) => {
  return questions.map((q) => {
    if (!q.answer) {
      q.hide = true;
    }
    return q;
  });
};
